import { useState } from 'react'
import CardLayout from '../../../components/utils/CardLayout'
import RepushActivation from './RepushActivation';
import PrepaidIQActivation from './PrepaidIQActivation'

const RepushctivationRequest = () => {
    const [activeTab, setActiveTab] = useState('Automation Activation');

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    const repushActivationPage = () => {
        return <RepushActivation />;
    }

    const prepaidActivationPage = () => {
        return <PrepaidIQActivation />;
    }

    return (
        <CardLayout title={activeTab}>
            <>
                <ul className="nav nav-tabs plan-tab" id="myTab" role="tablist" style={{ display: 'flex', gap: '2px' }}>
                    <li className="nav-item" role="presentation">
                        <button className={`nav-link ${activeTab === 'Automation Activation' ? 'active' : ''}`} onClick={() => handleTabClick('Automation Activation')} >
                            Automation Activation
                        </button>
                    </li>

                    <li className="nav-item" role="presentation">
                        <button className={`nav-link ${activeTab === 'PrepaidIQ Activation' ? 'active' : ''}`} onClick={() => handleTabClick('PrepaidIQ Activation')} >
                            PrepaidIQ Activation
                        </button>
                    </li>
                </ul>

                {activeTab == 'Automation Activation' && repushActivationPage()}
                {activeTab == 'PrepaidIQ Activation' && prepaidActivationPage()}
            </>
        </CardLayout>
    )
}

export default RepushctivationRequest